import React, { useEffect, useState } from 'react';
import project from '../../images/sidebar/projects.png'
import projectColor from '../../images/sidebar/projects-color.png'
import brands from '../../images/sidebar/brands.png'
import brandsColor from '../../images/sidebar/brands-color.png'
import entities from '../../images/sidebar/entities.png'
import entitiesColor from '../../images/sidebar/entities-color.png'
import contacts from '../../images/sidebar/contacts.png'
import contactsColor from '../../images/sidebar/contacts-color.png'
import websites from '../../images/sidebar/websites.png'
import websitesColor from '../../images/sidebar/websites-color.png'
import updates from '../../images/sidebar/updates.png'
import updatesColor from '../../images/sidebar/updates-color.png'
import resources from '../../images/sidebar/resources.png'
import resourcesColor from '../../images/sidebar/resources-color.png'
import sideopen from '../../images/sidebar/sideopen.png'
import sideclose from '../../images/sidebar/sideclose.png'
import downarrow from '../../images/common/bluedownarrow.png';
import uparrow from '../../images/common/blueuparrow.png';
import '../../scss/sidebar.scss';
import { useNavigate } from "react-router-dom";


function Sidebar(props) {
    const URL = window.location.href;
    const navigate = useNavigate();
    const [showProjects, setShowProjects] = useState(false);

    function MenuOpenClose() {
        if(document.getElementById('open-close').src === sideopen) {
            document.getElementById('open-close').src = sideclose;
            var pages = document.getElementsByClassName('pages');
            document.getElementsByClassName('sub-pages-arrow')[0].style.display = 'none';
            document.getElementsByClassName('project-section-left')[0].style.maxWidth = '65px';

            for (var i = 0; i < pages.length; i++) {
                document.getElementsByClassName('pages')[i].style.display = 'none';
                document.getElementsByClassName('side-bar-image')[i].setAttribute('style', 'margin-right: 0px');
            }
        }
        else {
            document.getElementById('open-close').src = sideopen;
            var pages = document.getElementsByClassName('pages');
            document.getElementsByClassName('sub-pages-arrow')[0].style.display = 'block';
            document.getElementsByClassName('project-section-left')[0].style.maxWidth = '175px';

            for (var i = 0; i < pages.length; i++) {
                document.getElementsByClassName('pages')[i].style.display = 'block';
                document.getElementsByClassName('side-bar-image')[i].setAttribute('style', 'margin-right: 8px');
            }
        }
    }

    const navigateToProjects = () => {
        setShowProjects(!showProjects)
        navigate('/projects/list?category=Active')
    }

    useEffect(() => {
        if(URL.includes('projects/schedule') || URL.includes('projects/project-spec')) {
            setShowProjects(true)
        }
    }, [])

    return (
        <div className='col-2 project-section-left'>
            <div className='side-image'>
                <img id='open-close' src={sideopen} alt='sidearrow' onClick={MenuOpenClose}></img>
            </div>
            <div className='side-bar-list-container'>
                <div className='side-bar-list' onClick={navigateToProjects} style={{background : `${window.location.href.includes('projects') ? 'rgb(22, 140, 208, 0.14)' : ''}`, color : `${window.location.href.includes('projects') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('projects') ? 'Lato-Semibold' : ''}`}}>
                    <div className='side-bar-image projects-icon'>
                        <img src={`${window.location.href.includes('projects') ? projectColor : project}`} alt='projects'></img>
                    </div>
                    <div className='pages'>
                        Projects
                    </div>
                    <div>
                        <img className='sub-pages-arrow' src={showProjects ? uparrow : downarrow} alt="arrow"/>
                    </div>
                </div>
                {showProjects &&
                <div className='side-bar-sub-list'>
                    <div className='sub-pages' onClick={() => navigate('/projects/schedule/list?category=Active')}
                    style={{color : `${window.location.href.includes('projects/schedule') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('projects/schedule') ? 'Lato-Semibold' : ''}`}}>
                        Schedule
                    </div>
                    <div className='sub-pages' onClick={() => navigate('/projects/project-spec/list?category=Active')}
                    style={{color : `${window.location.href.includes('projects/project-spec') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('projects/project-spec') ? 'Lato-Semibold' : ''}`}}>
                        Project Spec
                    </div>
                    <div className='sub-pages' onClick={() => navigate('/projects/list-request/list?category=Active')}
                    style={{color : `${window.location.href.includes('projects/list-request') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('projects/list-request') ? 'Lato-Semibold' : ''}`}}>
                        List Request
                    </div>
                </div>}
            </div>
            <div className='side-bar-list-container'>
                <div className='side-bar-list' onClick={() => navigate('/portals/list')} style={{background : `${window.location.href.includes('portals') ? 'rgb(22, 140, 208, 0.14)' : ''}`, color : `${window.location.href.includes('portals') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('portals') ? 'Lato-Semibold' : ''}`}}>
                    <div className='side-bar-image brands-icon'>
                        <img src={`${window.location.href.includes('portals') ? brandsColor : brands}`} alt='portals'></img>
                    </div>
                    <div className='pages'>
                        Portals
                    </div>
                </div>
            </div>
            <div className='side-bar-list-container'>
                <div className='side-bar-list' onClick={() => navigate('/properties/list')} style={{background : `${window.location.href.includes('properties') ? 'rgb(22, 140, 208, 0.14)' : ''}`, color : `${window.location.href.includes('properties') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('properties') ? 'Lato-Semibold' : ''}`}}>
                    <div className='side-bar-image entities-icon'>
                        <img src={`${window.location.href.includes('properties') ? entitiesColor : entities}`} alt='properties'></img>
                    </div>
                    <div className='pages'>
                        Properties
                    </div>
                </div>
            </div>
            <div className='side-bar-list-container'>
                <div className='side-bar-list' onClick={() => navigate('/contacts/list')} style={{background : `${window.location.href.includes('contacts') ? 'rgb(22, 140, 208, 0.14)' : ''}`, color : `${window.location.href.includes('contacts') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('contacts') ? 'Lato-Semibold' : ''}`}}>
                    <div className='side-bar-image contacts-icon'>
                        <img src={`${window.location.href.includes('contacts') ? contactsColor : contacts}`} alt='contacts'></img>
                    </div>
                    <div className='pages'>
                        Contacts
                    </div>
                </div>
            </div>
            <div className='side-bar-list-container'>
                <div className='side-bar-list' onClick={() => navigate('/websites/list')} style={{background : `${window.location.href.includes('websites') ? 'rgb(22, 140, 208, 0.14)' : ''}`, color : `${window.location.href.includes('websites') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('websites') ? 'Lato-Semibold' : ''}`}}>
                    <div className='side-bar-image portals-icon'>
                        <img src={`${window.location.href.includes('websites') ? websitesColor : websites}`} alt='websites'></img>
                    </div>
                    <div className='pages'>
                        Websites
                    </div>
                </div>
            </div>
            <div className='side-bar-list-container'>
                <div className='side-bar-list' onClick={() => navigate('/updates')} style={{background : `${window.location.href.includes('updates') ? 'rgb(22, 140, 208, 0.14)' : ''}`, color : `${window.location.href.includes('updates') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('updates') ? 'Lato-Semibold' : ''}`}}>
                    <div className='side-bar-image updates-icon'>
                        <img src={`${window.location.href.includes('updates') ? updatesColor : updates}`} alt='updates'></img>
                    </div>
                    <div className='pages'>
                        Updates
                    </div>
                </div>
            </div>
            <div className='side-bar-list-container'>
                <div className='side-bar-list' onClick={() => navigate('/cc-resources')} style={{background : `${window.location.href.includes('cc-resources') ? 'rgb(22, 140, 208, 0.14)' : ''}`, color : `${window.location.href.includes('cc-resources') ? '#059CDC' : ''}`, fontFamily : `${window.location.href.includes('cc-resources') ? 'Lato-Semibold' : ''}`}}>
                    <div className='side-bar-image resources-icon'>
                        <img src={`${window.location.href.includes('cc-resources') ? resourcesColor : resources}`} alt='resources'></img>
                    </div>
                    <div className='pages'>
                        Resources
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;